<template>
  <div class="flex-col page"
    :class="{
      xinwenzixun: selectedType === '2'
    }"
  >
    <div class="flex-col">
      <div class="flex-col group">
        <div
          class="flex-col justify-start items-center text-wrapper"
          :style="`background-image: url('${newsBg}')`"
        ><span class="text_6">资讯公告</span></div>
        <leftMenu
          title="资讯公告"
          sub-title="information"
        >
          <div class="flex-col group_3 ml-41">
            <div class="self-end group_4">
              <rightNav
                :navData="[
                  {title: '首页', path: '/'},
                  {title: '资讯公告', path: `/consultation?type=${selectedType}`},
                  {title: curName, path: `/consultation?type=${selectedType}`}
                ]"
              />
            </div>
          </div>
        </leftMenu>
      </div>
      <div class="flex-row justify-center items-center group_2">
        <leftMenuList
          :selectedType.sync="selectedType"
          :typeData="typeData"
          @handleSelectType="handleSelectType"
        />
        <div v-if="!isShowDetail" class="flex-col ml-41 listData">
          <div v-for="(item, index) in listData" class="flex-row items-center group_7" :key="index" @click="goDetail(item)">
            <span class="font_5">{{item.name}}</span>
            <span class="font_6 text_13">{{item.time}}</span>
          </div>
        </div>
        <div v-else class="flex-col ml-41 listData">
          <Detail
            :id="detailId"
          />
        </div>
      </div>
      <div v-if="!isShowDetail" class="flex-col group_9">
        <div class="flex-row justify-end self-stretch group_17">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="prev, pager, next"
            :current-page="page"
            :page-size="limit"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Detail from '../detail'
export default {
  components: {
    Detail
  },
  props: {},
  data () {
    const { newsBg } = this.$images
    return {
      newsBg,
      page: 1,
      limit: 10,
      total: 0,
      selectedType: '2',
      typeData: [
        { id: '2', name: '新闻资讯' },
        { id: '3', name: '政策法规' },
        { id: '4', name: '信息发布' }
      ],
      listData: [
        // { id: 1, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 2, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 3, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 3, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 3, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 3, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 3, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 3, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 3, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' },
        // { id: 4, name: '《中华人民共和国进出口商品检验法实施条例》', time: '2022-03-29' }
      ],
      isShowDetail: false, // 是否显示详情
      detailId: '' // 详情id
    }
  },

  computed: {
    calcItem () {
      return `/consultation?type=${this.selectedType}`
    },
    // 当前二级或三级菜单名
    curName () {
      let name = ''
      const arr = this.typeData
      arr.forEach(v => {
        if (v.id === this.selectedType) name = v.name
      })
      return name
    }
  },

  created () {
    const { query } = this.$route

    if (query.id) {
      this.isShowDetail = true
      this.detailId = query.id
      return
    }
    this.selectedType = query.type
    this.getNewsData()
  },

  methods: {
    async getNewsData () {
      const enumType = {
        2: 224,
        3: 225,
        4: 226
      }
      const res = await this.$https.getList({
        page: this.page,
        limit: this.limit,
        modeId: enumType[this.selectedType]
      })
      this.total = res.data.data.count
      this.listData = res.data.data.list.map(v => {
        return {
          id: v.id,
          name: v.title,
          time: v.create_time_date
        }
      })
    },
    handleCurrentChange (value) {
      console.log('handleCurrentChange==>', value)
      this.page = value
      this.getNewsData()
    },
    goDetail (item) {
      // 根据id获取详情数据
      const { id } = item
      this.isShowDetail = true
      this.detailId = id
    },
    handleSelectType (item) {
      this.isShowDetail = false
      this.detailId = ''

      const { id } = item
      this.selectedType = id
      this.page = 1

      // 如果类型有变化，请求列表数据
      this.getNewsData()
    }
  }
}
</script>

<style scoped lang="less">
  .listData{
    margin-top: -60px;
  }
  .ml-57 {
    margin-left: 57px;
  }
  .ml-67 {
    margin-left: 67px;
  }
  .ml-81 {
    margin-left: 81px;
  }
  .ml-5 {
    margin-left: 5px;
  }
  .ml-23 {
    margin-left: 23px;
  }
  .ml-41 {
    margin-left: 41px;
    /*margin-top: -229px;*/
    width: 1057px;
  }
  .ml-715 {
    margin-left: 715px;
  }
  .mt-25 {
    margin-top: 25px;
  }
  .ml-410 {
    margin-left: 410px;
  }
  .ml-619 {
    margin-left: 619px;
  }
  .ml-699 {
    margin-left: 699px;
  }
  .mt-514 {
    margin-top: 514px;
  }
  .ml-17 {
    margin-left: 17px;
  }
  .ml-13 {
    margin-left: 13px;
  }
  .mt-13 {
    margin-top: 13px;
  }
  .page {
    background-color: #ffffff;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      .section {
        padding: 53px 0 46px;
        background-color: #ffffff;
        .text_2 {
          color: #004290;
          font-size: 39px;
          font-family: Swiss721BT;
          font-weight: 900;
          line-height: 29px;
        }
        .text_3 {
          color: #004290;
          font-size: 32px;
          font-family: Alibaba;
          line-height: 34px;
        }
      }
      .section_2 {
        padding-left: 388px;
        padding-right: 377px;
        background-color: #006ed1;
        .section_3 {
          padding: 24px 13px 24px 28px;
          background-color: #004290;
          height: 64px;
        }
        .image {
          width: 13px;
          height: 8px;
        }
        .font_2 {
          font-size: 16px;
          font-family: PingFang;
          line-height: 16px;
          color: #ffffff;
        }
        .text_4 {
          line-height: 17px;
        }
        .text_5 {
          line-height: 15px;
        }
      }
      .text-wrapper {
        padding: 188px 0 146px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .text_6 {
          color: #ffffff;
          font-size: 26px;
          font-family: Alibaba;
          line-height: 25px;
        }
      }
      .view {
        margin-top: -27px;
      }
    }
    .group_2 {
      padding-left: 347px;
      padding-right: 255px;
      margin-top: -10px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      .section_4 {
        padding-top: 10px;
        background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=46097340cf817c540b55f5a5b24c3912.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 220px;
        height: 150px;
        .section_5 {
          padding: 35px 31px 44px;
          background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=284c6d4887fe7ecf15fd9485613ac270.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          width: 220px;
          .text_7 {
            color: #ffffff;
            font-size: 25px;
            line-height: 24px;
          }
          .text_10 {
            color: #ffffff;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            line-height: 12px;
            letter-spacing: 3px;
          }
        }
      }
      .group_3 {
        margin-top: 47px;
        width: 1057px;
        .group_4 {
          margin-right: 10px;
          line-height: 15px;

          .word{
            color: #666;
            cursor: pointer;
          }
          .font_4 {
            font-size: 14px;
            font-family: PingFang;
            font-weight: 700;
          }
          .text_8 {
            color: #cccccc;
            line-height: 14px;
          }
          .text_9 {
            color: #666666;
            line-height: 15px;
          }
        }
        .group_5 {
          margin-top: 44px;
        }
        .image_3 {
          margin-left: 3px;
          margin-top: 21px;
        }
      }
      .section_6 {
        padding: 26px 14px 32px;
        background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=7298094834b17028fa2b80491f241005.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 220px;
        .font_7 {
          font-size: 14px;
          font-family: PingFang;
          line-height: 19.5px;
          color: #2b303b;
        }
        .text_11 {
          width: 100%;
          padding-left: 25px;
          height: 42px;
          line-height: 42px;
          border-bottom: 1px solid #41AAAA;
          cursor: pointer;
          transition: all .2s linear;

          &:hover{
            color: #006ED1;
            border-bottom: 1px solid #006ED1;
          }

          &.active{
            color: white;
            background: #006ED1;
          }
        }
        .divider {
          background-color: #41aaaa;
          height: 1px;
        }
        .text_12 {
          margin-left: 25px;
        }
        .text-wrapper_2 {
          padding: 14px 0 10px;
          background-color: #006ed1;
          width: 191px;
          border-top: solid 1px #006ed18c;
          .text_14 {
            margin-left: 25px;
            color: #ffffff;
          }
        }
      }
      .group_6 {
        padding-bottom: 21px;
      }
      .image_4 {
        margin-left: 3px;
      }
      .group_7 {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 26px 0 22px;
        border-bottom: 1px dashed #c9c9c9;
        cursor: pointer;
        z-index: 20;

        &:hover {
          .font_5,
          .font_6 {
            color: #006ed1;
          }
        }
        .text_13 {
          line-height: 13px;
        }
      }
      .image_5 {
        margin-left: 3px;
      }
      .group_8 {
        padding-top: 22px;
      }
    }
    .text {
      text-transform: uppercase;
    }
    .group_9 {
      padding: 0 255px;
      margin-top: 23px;
      .group_10 {
        padding: 22px 7px;
        .text_15 {
          margin-left: 346px;
        }
        .text_16 {
          line-height: 13px;
        }
        .text_17 {
          margin-left: 347px;
        }
        .text_23 {
          margin-left: 346px;
        }
        .text_24 {
          line-height: 13px;
        }
        .text_25 {
          margin-left: 346px;
        }
        .text_26 {
          line-height: 13px;
        }
      }
      .image_6 {
        width: 1054px;
        height: 1px;
      }
      .group_11 {
        padding: 25px 7px 21px;
        .text_18 {
          margin-left: 347px;
        }
        .text_19 {
          line-height: 13px;
        }
        .text_20 {
          margin-left: 346px;
        }
      }
      .group_12 {
        padding: 26px 7px 21px;
        .text_21 {
          margin-left: 346px;
        }
        .text_22 {
          line-height: 13px;
        }
      }
      .group_13 {
        padding: 20px 7px;
        .text_27 {
          margin-left: 346px;
        }
      }
      .group_15 {
        width: 1054px;
        height: 1px;
        border-left: dashed 1px #dbdbdb;
        border-right: dashed 1px #dbdbdb;
        border-top: dashed 1px #dbdbdb;
        border-bottom: dashed 1px #dbdbdb;
      }
      .group_14 {
        padding: 25px 7px 22px;
        .text_28 {
          margin-left: 346px;
        }
        .text_29 {
          line-height: 13px;
        }
      }
      .group_16 {
        padding: 20px 6px;
        .text_30 {
          margin-left: 347px;
        }
      }
      .group_17 {
        padding: 20px 351px 0;
        padding-right: 200px;
        .text-wrapper_3 {
          padding: 12px 0;
          background-color: #ffffff;
          border-radius: 2px;
          width: 86px;
          height: 40px;
          border-left: dashed 0.5px #dcdcdc;
          border-right: dashed 0.5px #dcdcdc;
          border-top: dashed 0.5px #dcdcdc;
          border-bottom: dashed 0.5px #dcdcdc;
          .font_8 {
            font-size: 18px;
            font-family: SourceHanSansCN;
            line-height: 16px;
            color: #666666;
          }
          .text_31 {
            line-height: 17px;
          }
        }
        .image_7 {
          border-radius: 2px;
          width: 40px;
          height: 40px;
        }
        .text-wrapper_4 {
          padding: 12px 0;
          background-color: #006ed1;
          border-radius: 2px;
          width: 39px;
          height: 39px;
          .text_32 {
            color: #ffffff;
          }
        }
        .text-wrapper_5 {
          padding: 12px 0;
          background-color: #eeeeee;
          border-radius: 2px;
          width: 39px;
          height: 39px;
        }
        .font_9 {
          font-size: 18px;
          font-family: SourceHanSansCN;
          line-height: 14px;
          color: #666666;
        }
      }
    }
    .image_2 {
      width: 1054px;
      height: 2px;
    }
    .font_5 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 16px;
      color: #333333;
      max-width: 900px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
    .font_6 {
      font-size: 16px;
      font-family: PingFang;
      line-height: 12px;
      color: #999999;
    }
    .image_8 {
      margin-left: 267px;
      width: 26px;
      height: 26px;
    }
    .section_7 {
      padding: 63px 245px 0;
      background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=c32e8d97bd64785c4b4ddf9199a9d4c6.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .text-wrapper_6 {
        padding: 15px 0;
        background-color: #006ed1;
        width: 164px;
        .text_33 {
          line-height: 17px;
        }
      }
      .group_18 {
        padding: 26px 6px 49px;
        .text-wrapper_7 {
          flex: 1 1 446px;
          padding: 28px 0;
          background-color: #e0edf9;
          height: 75px;
          border-left: solid 1px #006ed1;
          border-right: solid 1px #006ed1;
          border-top: solid 1px #006ed1;
          border-bottom: solid 1px #006ed1;
        }
      }
    }
    .font {
      font-size: 18px;
      font-family: PingFang;
      line-height: 18px;
      color: #ffffff;
    }
    .section_8 {
      padding: 8px 235px 40px 359px;
      background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=4d8bf3509965beb0a8e3667c993b2b6a.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .group_19 {
        margin-top: 39px;
        .image_9 {
          width: 41px;
          height: 41px;
        }
        .text_34 {
          color: #b2b3b8;
        }
        .group_20 {
          margin-top: 25px;
          .group_21 {
            margin-bottom: 4px;
            .image_10 {
              margin-bottom: 3px;
              width: 40px;
              height: 43px;
            }
            .text_35 {
              line-height: 15px;
            }
            .text_36 {
              color: #006ed1;
              font-size: 24px;
              font-family: PingFang;
              font-weight: 700;
              line-height: 20px;
            }
          }
          .image_12 {
            width: 48px;
            height: 36px;
          }
          .text_37 {
            color: #006ed1;
          }
        }
        .group_23 {
          margin-top: 30px;
          .font_11 {
            font-size: 14px;
            font-family: PingFang;
            line-height: 12px;
            color: #939598;
          }
          .text_40 {
            line-height: 11px;
          }
          .text_39 {
            margin-left: 3px;
            line-height: 11px;
          }
          .text_41 {
            margin-left: 45px;
            line-height: 11px;
          }
          .text_42 {
            margin-left: 3px;
            line-height: 11px;
          }
        }
        .image_11 {
          margin-left: 3px;
          width: 31px;
          height: 43px;
        }
        .group_22 {
          margin-left: 10px;
          .text_38 {
            color: #006ed1;
            font-size: 20px;
            font-family: PingFang;
            line-height: 19px;
          }
        }
        .font_10 {
          font-size: 16px;
          font-family: PingFang;
          line-height: 16px;
          color: #b2b3b8;
        }
      }
      .section_9 {
        background-color: #2e3142;
        width: 204px;
        height: 188px;
      }
    }
    .font_3 {
      font-size: 24px;
      font-family: PingFang;
      line-height: 23px;
    }
  }
</style>
